// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"dbaeb697bf8bea173469","293":"6bc6447d8850b2773e0f","461":"18e7f8791a00e7599b93","518":"8ec92ce8ecf07a9b4cdc","779":"cc95fcf28a0694bcde2e"}[chunkId] + ".js";
};